import { Link } from 'react-router-dom';
import { GovIcon } from '@gov-design-system-ce/react';
import { useConfiguration, useLocale } from '@gov-nx/core/service';
import { useDataBoxesContext } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button, CopyButton, Dialog, LayoutGap } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';

export const DataBoxSupportModal = () => {
	const { t } = useLocale(PageCode['datove-schranky']);
	const { isSupportModalOpen } = useDataBoxesContext();

	const { napovedaDatoveSchrankyUrl, portalObcanaEmail } = useConfiguration();

	return (
		<Dialog
			isOpen={isSupportModalOpen.isTrue}
			onClose={isSupportModalOpen.setFalse}
			title={<h3>{t('schranky.napoveda')}</h3>}>
			<LayoutGap gap="xl">
				{napovedaDatoveSchrankyUrl && (
					<LayoutGap gap="m">
						<div>{t('napoveda.vice-o-datovych-schrankach')}</div>
						<Button
							asChild
							color="primary"
							type="outlined"
							size="m"
							isExpandedMobile
							aria-label={t('napoveda.prejit-na-gov')}
							iconEnd={
								<GovIcon
									type="components"
									name="box-arrow-up-right"
								/>
							}>
							<Link
								to={napovedaDatoveSchrankyUrl}
								target="_blank">
								{t('napoveda.prejit-na-gov')}
							</Link>
						</Button>
					</LayoutGap>
				)}
				<LayoutGap gap="m">
					<div>{t('napoveda.napiste-na-podporu')}</div>
					<div className="flex flex-col items-start gap-2 [ sm:flex-row sm:gap-4 sm:items-center ]">
						<Button
							asChild
							color="primary"
							type="outlined"
							size="m"
							isExpandedMobile
							aria-label={t('napoveda.formular-podpory')}
							iconEnd={
								<GovIcon
									type="templates"
									name="question-circle"
								/>
							}>
							<Link
								to={pageRouteResolver(PageCode['podpora'])}
								target="_blank">
								{t('napoveda.formular-podpory')}
							</Link>
						</Button>
						<div className="w-full [ md:w-auto ]">
							<Button
								asChild
								color="primary"
								type="link"
								size="m"
								isExpandedMobile
								iconEnd={
									<CopyButton
										color="primary"
										size="m"
										label={t('akce.zkopirovat-emailovou-adresu')}
										value={portalObcanaEmail}
									/>
								}>
								<Link to={'mailto:' + portalObcanaEmail}>
									{portalObcanaEmail}
								</Link>
							</Button>
						</div>
					</div>
				</LayoutGap>
			</LayoutGap>
		</Dialog>
	);
};
